@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';

.modal-body {
  padding: 20px 20px 40px;
}

.items-grid {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;
  padding-top: 25px;
  padding-bottom: 15px;
  border-bottom: 1px solid @review-adjustments-modal--items-grid--border-color;
}

.column-header {
  border-bottom: 1px solid @review-adjustments-modal--header--border-color;
  padding: 5px 0;
  font-weight: @bold;
}
.column-data {
  padding: 10px 5px 0 0;
  color: @review-adjustments-modal--column--text-color;
}

.quantity-column {
  text-align: center;
}
